import { Numbers } from "../constants/Referral";
import { NppesPayloadData } from "../models/PhysicianDetails";
import { AgencyListPayload } from "../models/ProviderMaterials";
import { GetQueryString } from "../utils";
import API from "./api";

export const GetMfaMaster = (config: string) =>
  API.get(`${config}api/Provider/GetMfaDetails`);

export const GetMasterRole = (config: string) =>
  API.get(`${config}api/Provider/GetRoles`);

export const GetMasterServiceProvider = (
  config: string,
  maxCount: number,
  payload?: AgencyListPayload
) =>
  payload && payload.healthPlanId && payload.healthPlanId > Numbers.ZERO

    ? API.get(`${config}api/Operator/all/1/${maxCount}/${false}?email=${payload.email}&healthPlanId=${payload.healthPlanId}&benefitPlanId=${payload.benefitPlanId}&excludeExpired=${true}`)
    : API.get(`${config}api/Operator/all/1/${maxCount}/${false}`);

    export const GetMasterHealthPlan = (config: string) => 
    API.get(`${config}api/ReferralService/EligibilityHealthPlan`);

export const GetMasterCareType = (config: string) => 
  API.get(`${config}api/ReferralService/CareTypes`);

export const GetDisciplineList = (config: string, eligibilityId: number, isPortal: boolean, type?: number) =>
  eligibilityId === 0 ? API.get(`${config}api/ReferralService/Disciplines?patientEligibilityId=1&isPortalPreAuth=${isPortal}&type=${type}`) :
API.get(`${config}api/ReferralService/Disciplines?patientEligibilityId=${eligibilityId}&isPortalPreAuth=${isPortal}&type=${type}`);

export const GetMasterSendCommunicationAuth = (config: string) =>
  API.get(`${config}api/Patients/GetApprovedAuthCommunicationTypeAsync`);

export const GetMasterReferralSource = (config: string) =>
  API.get(`${config}api/ReferralService/ReferralSourceType`);

export const GetMasterDocumentType = (config: string) =>
  API.get(`${config}api/ReferralService/GetDocumentTypeMaster`);

export const GetMasterDocumentNotes = (config: string) =>
  API.get(`${config}api/ReferralService/GetDocumentNotes`);

export const GetFeatureAccessData = (config: string) =>
  API.get(`${config}api/Admin/GetFeatureAccess?featureId=0`);

export const GetMasterServiceProviderDefault = (
  config: string, maxCount: number,
) => API.get(`${config}api/Operator/all/1/${maxCount}/${false}`);

export const GetNPPESDetailsData = (
  configUrl: string,
  payload: NppesPayloadData
) => API.get(`${configUrl}api/ReferralService/NppesSearch/Results?${GetQueryString(payload)}`);

export const GetDischargeReason = (
  configUrl: string,
) => API.get(`${configUrl}api/ReferralService/DischargeReason?isNoMNC=true`);

export const GetNotificationType = (configUrl: string) => 
  API.get(`${configUrl}api/Notifications/getNotificationTypes`);

export const GetLanguageMaster = (configUrl: string) =>
  API.get(`${configUrl}api/ReferralService/GetLanguageMaster`);